import type { Lucid } from '../../types/types';

type CompetitorLink = {
  label: string;
  value: string;
};

const isCompetitor = (
  data:
    | Lucid.Directus.Generated.Competitor
    | Lucid.Directus.Generated.Competitor_2
    | Lucid.Directus.Generated.Chart_Og_Competitor,
): data is Lucid.Directus.Generated.Competitor | Lucid.Directus.Generated.Competitor_2 =>
  'competitor' in data && !!data.competitor;

type WithCompetitorType = (
  directus: {
    competitorPages: Lucid.Directus.Generated.Competitor[];
    competitor2Pages: Lucid.Directus.Generated.Competitor_2[];
    ogCompetitorPages?: Lucid.Directus.Generated.Chart_Og_Competitor[];
  },
  templateProduct: Lucid.Site.Product,
  languageKey: Lucid.I18n.LanguagesShortCode,
) => {
  competitorPages: CompetitorLink[];
};

const withCompetitor: WithCompetitorType = (directus, templateProduct, languageKey) => {
  const { competitorPages, competitor2Pages, ogCompetitorPages } = directus;
  const allCompetitorPages = [...competitor2Pages, ...competitorPages, ...(ogCompetitorPages || [])];
  const competitors = allCompetitorPages
    .filter(page =>
      templateProduct === 'scale' && page.translations
        ? page.translations?.[0]?.path?.url?.includes('/lucidscale/')
        : page.translations && !page.translations?.[0]?.path?.url?.includes('/lucidscale/'),
    )
    .reduce((uniqueCompetitors, page) => {
      const { translations } = page;
      const label = isCompetitor(page) ? page.competitor || '' : page?.competitor_type?.name || '';
      const translatedPage = translations?.find(t => t.languages_code?.short_code === languageKey);

      if (!translatedPage || !translatedPage.path) {
        return uniqueCompetitors;
      }

      if (translatedPage && !uniqueCompetitors.find(c => c.label === label)) {
        return [...uniqueCompetitors, { label, value: translatedPage?.path?.url || '' }];
      }

      return uniqueCompetitors;
    }, [] as CompetitorLink[])
    .sort((a, b) => a.label.localeCompare(b.label));

  return {
    competitorPages: competitors,
  };
};

export default withCompetitor;
